/**
 * OrgChartEditor — PropertyEditor registration for the 'org-chart' control type.
 *
 * SRP: this file's only job is to bridge the PropertyEditorProps interface
 * (used by PropertyEditorRegistry) to the standalone OrgChartPropertyEditor component.
 * All UI logic lives in ../OrgChartPropertyEditor.tsx.
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';
import { OrgChartPropertyEditor } from '../OrgChartPropertyEditor';

function getIsDark(): boolean {
  return (
    typeof document !== 'undefined' &&
    document.documentElement.classList.contains('dark')
  );
}

function renderOrgChartEditor(props: PropertyEditorProps): React.ReactNode {
  const { control, onControlChange } = props;

  return (
    <OrgChartPropertyEditor
      control={control}
      onUpdateControl={(patch) => onControlChange(patch)}
      isDark={getIsDark()}
    />
  );
}

export const OrgChartEditor: PropertyEditor = {
  type: 'org-chart',
  label: 'Org Chart',
  description: 'Configure org chart data, field mappings, layout, card style, node actions, and dynamic links',
  version: '1.0.0',
  render: renderOrgChartEditor,
};
